import { memoize } from 'lodash/fp';
import React from 'react';
import {
  GeoSkeletonCardWrapper,
  GeoSkeletonTitleWrapper,
} from 'components/domain/geo/Geo.common.styles';
import SkeletonBaseBlock from 'components/domain/skeleton/SkeletonBaseBlock';

function ItemCardPlaceholder(): React.ReactElement {
  return (
    <GeoSkeletonCardWrapper>
      <SkeletonBaseBlock height="274px" width="100%" />
      <GeoSkeletonTitleWrapper>
        <SkeletonBaseBlock height="20px" width="220px" borderRadius="6px" />
        <SkeletonBaseBlock
          height="24px"
          width="24px"
          borderRadius="6px"
          style={{ marginRight: '10px' }}
        />
      </GeoSkeletonTitleWrapper>
    </GeoSkeletonCardWrapper>
  );
}

const FdrSimilarDestinationsSkeleton = memoize(() => <ItemCardPlaceholder />);

export default FdrSimilarDestinationsSkeleton;
